import { ArrowUpRight, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import { FOOTER_GROUPS, SITE } from "@/config/site";

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="footer-main">
        <div className="footer-brand-column">
          <Link to="/" className="footer-logo-link" data-testid="footer-logo-link">
            <img src={SITE.assets.logo} alt="Vmemoo" className="footer-logo" />
          </Link>
          <p className="footer-company">{SITE.company}</p>
          <p className="footer-note">A virtual memory space for the people, pets and moments that matter.</p>
          <a className="footer-email" href={`mailto:${SITE.contacts.general}`} data-testid="footer-general-email-link">
            <Mail size={15} aria-hidden="true" /> {SITE.contacts.general}
          </a>
        </div>
        <div className="footer-nav-grid">
          {FOOTER_GROUPS.map((group) => (
            <div key={group.title} className="footer-group">
              <p className="footer-group-title">{group.title}</p>
              {group.links.map((link) => (
                <a key={link.id} href={link.href} data-testid={`footer-${link.id}-link`}>{link.label}</a>
              ))}
            </div>
          ))}
        </div>
      </div>
      <div className="footer-bottom">
        <span>© {year} {SITE.company}</span>
        <span className="footer-bottom-note">Made for the stories that stay with us <span aria-hidden="true">↗</span></span>
        <a href="/#top" data-testid="footer-back-to-top-link">Back to top <ArrowUpRight size={14} aria-hidden="true" /></a>
      </div>
    </footer>
  );
}
